<template>
  <div>
    <div class="favorites-section mt-16">
      <h2 class="text-5xl font-bold mb-6" role="heading" aria-level="3">Favorites</h2>

      <!-- Loading indicator -->
      <div v-if="loading" class="text-left">
        <p class="text-2xl">Loading favorites...</p>
      </div>

      <!-- No favorites message -->
      <div v-else-if="favorites.length === 0" class="text-left">
        <p class="text-2xl">You don't have any favorites yet. To add a favorite, navigate to an advertiser's specific vertical and click the yellow star in the navigation bar.</p>
      </div>

      <!-- Favorites grid -->
      <div v-else class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
        <div v-for="favorite in favorites" :key="`${favorite.advertiser_id}-${favorite.vertical}`" class="relative bg-white border border-gray-300 p-4 flex flex-col h-full">
          <button @click="confirmDelete(favorite)" type="button" class="absolute top-0 right-2 text-gray-500 hover:text-gray-700 text-6xl leading-[27px] bg-transparent border-none" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <a :href="buildAdvertiserVerticalLink(favorite)" class="flex flex-col h-full no-underline hover:no-underline group">
            <div class="flex-grow flex items-start">
              <img :src="getLogoUrl(favorite.advertiser_id)" :alt="`${favorite.vertical_label} Logo`" class="w-1/2 mb-3 mt-12">
            </div>
            <div class="mt-auto w-full">
              <p class="text-gray-600 text-uppercase text-left group-hover:text-blue-600 transition-colors duration-200">{{ favorite.vertical_label }}</p>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- Confirmation Modal -->
    <div v-if="showConfirmModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div class="bg-white p-6 rounded-lg">
        <p class="mb-4">Are you sure you want to remove this favorite?</p>
        <div class="flex justify-end">
          <button @click="cancelDelete" class="mr-2 px-4 py-2 bg-gray-200 rounded">Cancel</button>
          <button @click="deleteFavorite" class="px-4 py-2 bg-red-500 text-white rounded">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      favorites: [],
      showConfirmModal: false,
      favoriteToDelete: null,
      loading: true,
    };
  },
  mounted() {
    this.fetchFavorites();
  },
  methods: {
    async fetchFavorites() {
      this.loading = true;
      try {
        const response = await axios.get('/api/favorite/advertiser-vertical');
        this.favorites = response.data;
      } catch (error) {
        console.error('Error fetching favorites:', error);
      } finally {
        this.loading = false;
      }
    },
    getLogoUrl(advertiserId) {
      return `https://www.brimg.net/system/img/inst/${advertiserId}_hires_logo_2x.png`;
    },
    confirmDelete(favorite) {
      this.favoriteToDelete = favorite;
      this.showConfirmModal = true;
    },
    cancelDelete() {
      this.showConfirmModal = false;
      this.favoriteToDelete = null;
    },
    async deleteFavorite() {
      try {
        await axios.delete(`/api/favorite/advertiser-vertical/${this.favoriteToDelete.advertiser_id}/${this.favoriteToDelete.vertical}`);
        await this.fetchFavorites();
        this.showConfirmModal = false;
        this.favoriteToDelete = null;
      } catch (error) {
        console.error('Error deleting favorite:', error);
      }
    },
    buildAdvertiserVerticalLink(favorite) {
      return `/campaigns/${encodeURIComponent(favorite.vertical)}?switchToAdvertiserId=${favorite.advertiser_id}`;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
